var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"message"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/img/nofound.png"),"alt":""}}),(_vm.title)?_c('p',{staticClass:"call-word"},[_vm._v(" 暂无患者发起"+_vm._s(_vm.title)+"申请！ ")]):_vm._e(),(_vm.noDataText)?_c('p',{staticClass:"call-word"},[_vm._v(" "+_vm._s(_vm.noDataText)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }